// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__3MvuN","title":"Images45_title__GYABD","images":"Images45_images__13rsE"};